module.exports = __webpack_public_path__ + "img/1501993614.084f3f46.jpg";